<template>
  <b-row>
    <b-col>
      <b-form-group :label="label" :label-for="fieldName">
        <b-form-input
          :id="fieldName"
          :placeholder="placeHolder"
          :required="required"
          v-model="localValue"
          type="number"
          :step="step"
          :max="max"
          :min="min"
          v-bind="$attrs"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    fieldName: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeHolder: {
      type: String,
      default: "",
      required: false
    },
    required: {
      type: Boolean,
      default: false,
      required: false
    },
    step: {
      type: Number,
      required: false,
      default: 0
    },
    max: {
      type: Number,
      required: false,
      default: null
    },
    min: {
      type: Number,
      required: false,
      default: null
    },
    value: {
      type: Number,
      required: true,
      default: 0
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", parseFloat(val));
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
